import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PendingMessagesComponent } from 'shared/components/pending-messages/pending-messages.component';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { TooltipModule } from 'shared/components/tooltip/tooltip.module';
import { CustomPipesModule } from 'shared/pipes/custom-pipes.module';
import { InactiveWidgetFooterModule } from './components/inactive-widget-footer/inactive-widget-footer.module';
import { ConfirmationModalComponent } from 'shared/components/confirmation-modal/confirmation-modal.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule,
    TooltipModule,
    CustomPipesModule,
    InactiveWidgetFooterModule
  ],
  declarations: [
    PendingMessagesComponent,
    ConfirmationModalComponent
  ],
  exports: [
    InactiveWidgetFooterModule,
    PendingMessagesComponent,
    ConfirmationModalComponent
  ]
})
export class WorkItemWidgetSharedModule {}
